import axios from '../axios'


// // 筛选全部通过审核的信息
// export const select = (data) => {
//   return axios({
//     url: '/sysInfo/selectList',
//     method: 'post',
//     data
//   })
// };
// 筛选该类型通过审核的信息
export const list = (data) => {
  return axios({
    url: '/sysInfo/select',
    method: 'post',
    data
  })
};

// 查看
export const view = (data) => {
  return axios({
    url: '/sysInfo/view',
    method: 'post',
    data
  })
};
// 获取附件
export const getAttachByIds = (data) => {
  return axios({
    url: '/sysAttach/getAttachByIds',
    method: 'post',
    data
  })
};




// WEBPACK FOOTER //
// ./src/http/moudules/infoMenu.js